import 'moment-timezone';
import moment from "moment"
import { GetValue, HasProperty, IgnoreTimeZoneApiDate } from "../../Helpers/helper";

export interface IMenuModel {
    Id: number;
    Name?: string;
    Url?: string;
    MenuId: number;
    Created?: Date;
    Creator: number;
    Modified?: Date;
    Type: string;
    Order: number;
    SubMenus: IMenuModel[];

    //#region Setters

    SetId: (value: number) => IMenuModel;
    SetName: (value: string) => IMenuModel;
    SetURL: (value: string) => IMenuModel;
    SetMenuId: (value: number) => IMenuModel;
    SetCreated: (value: Date) => IMenuModel;
    SetCreator: (value: number) => IMenuModel;
    SetModified: (value: Date) => IMenuModel;
    SetType: (value: string) => IMenuModel;
    SetOrder: (value: number) => IMenuModel;
    SetSubMenus: (value: IMenuModel[]) => IMenuModel;

    //#endregion

    LoadFromAPI: (response: any) => IMenuModel;
    IsValid: () => boolean;
    Validate: () => string[];
    ToJson: () => string;
}

export default class MenuModel implements IMenuModel {
    Id!: number;
    Name?: string;
    Url?: string;
    MenuId!: number;
    Created?: Date;
    Creator!: number;
    Modified?: Date;
    Type!: string;
    Order!: number;
    LoggedUserCompany!: number
    SubMenus!: IMenuModel[];

    constructor() {
        this.Id = this.MenuId = this.Creator = this.Order = 0;
        this.Created = this.Modified = moment().toDate();
        this.Name = this.Type = "";
        this.SubMenus = []
    }

    //#region Setters

    SetId = (value: number): IMenuModel => {
        this.Id = value!
        return this;
    };

    SetName = (value: string): IMenuModel => {
        this.Name = value;
        return this;
    }

    SetURL = (value: string): IMenuModel => {
        this.Url = value;
        return this;
    }

    SetMenuId = (value: number): IMenuModel => {
        this.MenuId = value!;
        return this;
    }

    SetCreated = (value: Date): IMenuModel => {
        this.Created = value!;
        return this;
    }

    SetCreator = (value: number): IMenuModel => {
        this.Creator = value!;
        return this;
    }

    SetModified = (value: Date): IMenuModel => {
        this.Modified = value
        return this;
    }

    SetType = (value: string): IMenuModel => {
        this.Type = value!
        return this;
    }

    SetOrder = (value: number): IMenuModel => {
        this.Order = value!;
        return this;
    }

    SetSubMenus = (value: IMenuModel[]): IMenuModel => {
        this.SubMenus = value!;
        return this;
    }

    //#endregion

    LoadFromAPI = (response: any): IMenuModel => {
        const apiCreated: string = GetValue(response, "Created"),
            apiModified: string = GetValue(response, "Modified");

        /**
         * be carefull when modify because props must match with MenuDto and MenuVm in back (API response)
         */

        this.Id = GetValue(response, "id") as number;
        this.Name = GetValue(response, "name") as string;
        this.Url = GetValue(response, "url") as string
        this.MenuId = GetValue(response, "menuId") as number;
        this.Created = (apiCreated && IgnoreTimeZoneApiDate(apiCreated)) || this.Created;
        this.Creator = GetValue(response, "criadoPorId") as number;
        this.Modified = (apiModified && IgnoreTimeZoneApiDate(apiModified)) || this.Modified;
        this.Type = GetValue(response, "type") as string;
        this.Order = GetValue(response, "order");

        const subMenus: any[] = GetValue(response, "subMenus")?.$values || [];
        this.SubMenus = subMenus.map(menu => new MenuModel().LoadFromAPI(menu));

        return this;
    }

    IsValid = (): boolean => {

        const hasValidString: boolean = (this.Name != null && this.Name != "") && (this.Type != null && this.Type != "") && (this.Url != null && this.Url != ""),
            hasValidDate: boolean = this.Created != null && this.Modified != null,
            hasValidNumber: boolean = (this.Id != null && this.Id >= 0) && (this.MenuId != null && this.MenuId >= 0)
                && (this.Creator != null && this.Creator >= 0) && (this.LoggedUserCompany != null && this.LoggedUserCompany >= 0) && (this.Order != null),
            result = hasValidString && hasValidDate && hasValidNumber;

        return result;
    }

    Validate = (): string[] => {
        const validations: string[] = [];

        ((this.Id == null || this.Id < 0) && validations.push("Id must be a positive interger or zero."));
        ((this.Name == null || this.Name == "") && validations.push("Name could not be null or empty."));
        ((this.Url == null || this.Url == "") && validations.push("Url could not be null or empty."));
        ((this.MenuId == null || this.MenuId < 0) && validations.push("Menu Id must be a positive interger or zero."));
        (this.Created == null && validations.push("Creation time could not be null."));
        ((this.Creator == null || this.Creator < 0) && validations.push("Creator Id must be a positive interger or zero."));
        (this.Modified == null && validations.push("Modified time could not be null."));
        ((this.Type == null || this.Type == "") && validations.push("Type could not be null or empty."));
        (this.Order == null && validations.push("Order could not be null."));
        ((this.LoggedUserCompany == null || this.LoggedUserCompany < 0) && validations.push("Company' logged user Id must be a positive interger or zero."));

        return validations;
    }

    ToJson = (): string => {
        const dto = {
            id: this.Id,
            name: this.Name?.trim(),
            url: this.Url?.trim(),
            menuId: this.MenuId,
            created: moment(this.Created).format(),
            criadoPorId: this.Creator,
            modified: moment(this.Modified).format(),
            type: this.Type,
            order: this.Order,
        },
            result: string = JSON.stringify(dto);
        return result;
    }
}